import { render, staticRenderFns } from "./CList.vue?vue&type=template&id=05ff6be0&"
import script from "./CList.vue?vue&type=script&lang=js&"
export * from "./CList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports